export const INPUT_ERROR_CLASS = 'input-error';
export const GENERIC_ERROR_CLASS = 'error';
export const EMPTY_CLASS = '';
